function mapParamsToBody(id) {
  /* eslint-disable @typescript-eslint/camelcase */
  return id === 'all'
    ? {
      delete_all: 1,
    }
    : {
      id: id,
    }
}

export function deleteNotifications(fetch: GlobalFetch) {
  return async function(id: number | number[] | 'all') {
    const body = mapParamsToBody(id)

    const response = await fetch.fetch(`/api/v2/notification/delete`, {
      body: JSON.stringify(body),
      method: 'POST',
    })
    return await response.json()
  }
}
